import React from "react";
import { useTranslation } from "react-i18next";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import { useDispatch } from "react-redux";
import "./ContentExpansion.scss";

const ContentExpansion = ({ expand, reducer, classnames = "" }) => {
  const { t } = useTranslation("translation");

  if (expand) {
    return (
      <ExpansionDivBox expand={expand} classnames={classnames} reducer={reducer}>
        <FaAngleUp size={20} className="expansionToggleArrow" />
        {t("hideDetails")}
      </ExpansionDivBox>
    );
  } else {
    return (
      <ExpansionDivBox expand={expand} classnames={classnames} reducer={reducer}>
        <FaAngleDown size={20} className="expansionToggleArrow" />
        {t("showDetails")}
      </ExpansionDivBox>
    );
  }
};

const ExpansionDivBox = (props) => {
  const dispatch = useDispatch();

  function expansioOnClick(expand, reducer) {
    dispatch(reducer(!expand));
  }

  return (
    <div className="col-md-8">
      <div className="row expansionRow">
        <div className="col-9"></div>
        <div className="col-3">
          <div className="ContentExpansion">
            <div
              className={`expansionToggleBox d-flex flex-row-reverse ${props.classnames}`}
              onClick={() => expansioOnClick(props.expand, props.reducer)}
            >
              {props.children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentExpansion;
